import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Cookies from 'js-cookie';
import en from "./locales/en/en.json";
import sv from "./locales/sv/sv.json";
import es from "./locales/es/es.json";
import nb from "./locales/nb/nb.json";

const resources = {
  en: en,
  sv: sv,
  es: es,
  nb: nb
};
const savedLanguage = Cookies.get('locale') || 'en';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage, // default language
  fallbackLng: "en", // fallback language
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  supportedLngs: ['en', 'es', 'sv', 'nb']
});

export default i18n;
